import styled from "styled-components";
// *copied
export const StyledLabel = styled.label`
    font-size: 14px;
    font-weight: 400;
    color: #69707d;
    color: #69707d;
    display: flex;
    flex-direction: row;
    padding-bottom: 15px;
`;
// *copied

export const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
// *copied

export const StyledRequired = styled.span`
    color: red;
`;
// *copied

export const Error = styled.label`
    margin-top: 8px;
    color: #ff0000;
    font-size: 0.8rem;
`;
// *copied
export const Hint = styled.div`
    display: flex;
`;
export const SelectedContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem 0;
    flex: 1;
`;
export const DownloadContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid rgba(19, 34, 149, 0.1);
    border-radius: 6px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #0077cc;
    span {
        color: #343741;
        font-weight: 500;
        font-size: 16px;
    }
`;
